import React, { useEffect, useState } from "react";

import RgbPhoto from "./RgbPhoto";
import { useModalChrome } from "./useModalChrome";

type Props = {
  token: string;
  /** Fotos a exibir; lista vazia/null fecha o modal. */
  assetIds: string[] | null;
  title: string;
  onClose: () => void;
};

export default function RgbPhotoViewerModal({ token, assetIds, title, onClose }: Props) {
  const [index, setIndex] = useState(0);
  const isOpen = Boolean(assetIds?.length);
  useModalChrome(isOpen, onClose);

  useEffect(() => setIndex(0), [assetIds]);

  if (!isOpen || !assetIds) return null;
  const total = assetIds.length;

  return (
    <div className="rgbModalOverlay" onClick={onClose}>
      <div
        className="rgbModal"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="rgbModal__header">
          <h2 className="rgbModal__title">{title}</h2>
          <button type="button" className="rgbModal__close" onClick={onClose} aria-label="Fechar">
            ×
          </button>
        </div>
        <div className="rgbModal__body">
          <div className="rgbViewer">
            <RgbPhoto token={token} assetId={assetIds[index]} alt={`Foto ${index + 1} de ${total}`} />
            {total > 1 ? (
              <span className="rgbMuted">
                Foto {index + 1} de {total}
              </span>
            ) : null}
          </div>
        </div>
        {total > 1 ? (
          <div className="rgbModal__footer">
            <button
              type="button"
              className="rgbBtn rgbBtn--secondary"
              disabled={index === 0}
              onClick={() => setIndex((i) => i - 1)}
            >
              Anterior
            </button>
            <button
              type="button"
              className="rgbBtn rgbBtn--secondary"
              disabled={index === total - 1}
              onClick={() => setIndex((i) => i + 1)}
            >
              Próxima
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
